// Added by Sejune Oh on 2019-08-22
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Property } from 'csstype'
import { Theme } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) => ({
    HeaderWrapper: {
        marginBottom: `${theme.spacing()}px`,
        display: 'flex' as Property.Display,
        flexDirection: 'column' as Property.FlexDirection,
    },
    CPLogo: {
        fontWeight: 'bold' as Property.FontWeight,
        background: 'linear-gradient(to right, #187db1, #18b1b1)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontSize: '2.5rem',
    },
    Wrapper: {
        position: 'fixed' as Property.Position,
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        zIndex: 1302,
    },
    Input: {
        marginBottom: `${theme.spacing() * 2}px`,
    },
    AutoFocusableInput: {
        padding: '9px 7px',
        margin: '9px 7px',
        borderRadius: '4px',
    },
    TextFieldWrapper: {
        display: 'flex',
        flexDirection: 'column' as Property.FlexDirection,
    },
    BottomWrapper: {
        display: 'flex',
        flexDirection: 'column' as Property.FlexDirection,
    },
    BtnWrapper: {
        display: 'flex',
    },
    ScreenLockWrapper: {
        width: '600px',
        height: '450px',
        background: '#292a2c',
        boxShadow:
            '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
        borderRadius: '4px',
        position: 'absolute' as Property.Position,
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        margin: 'auto',
        display: 'flex',
    },
    ScreenLockRightWrapper: {
        flex: '1',
        display: 'flex',
        padding: `${theme.spacing() * 2}px`,
        position: 'relative' as Property.Position,
        flexDirection: 'column' as Property.FlexDirection,
        justifyContent: 'space-between',
    },
    LockBtn: {
        marginTop: `${theme.spacing()}px`,
        height: '45px',
        fontSize: '18px',
        width: '100% !important',
        '&:first-child': {
            marginRight: `${theme.spacing()}px`,
        },
    },
    CPLogoImgWrapper: {
        height: '46px',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        display: 'block',
    },
    DescTextWrapper: {
        lineHeight: 1.5,
    },
    BGWrapper: {
        position: 'relative' as Property.Position,
        width: '100%',
        height: '100%',
        backgroundSize: 'cover, auto 100%',
        backgroundRepeat: 'no-repeat',
        filter: 'grayscale(80%)',
    },
    ScreenLockLeftWrapper: {
        display: 'flex',
        flexBasis: '160px',
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat',
        position: 'relative' as Property.Position,
    },
    LoginPaperCopyRight: {
        position: 'absolute' as Property.Position,
        bottom: '-35px',
        left: '0',
        right: '0',
        fontSize: '12px',
        color: '#cdcdcd',
    },
    PWCheckDescWrapper: {
        marginTop: `${theme.spacing() * 1.5}px`,
        color: 'rgba(255, 255, 255, 0.65)',
    },
    PWCheckDescTitleWrapper: {
        paddingBottom: `${theme.spacing() / 2}px`,
        display: 'flex',
        alignItems: 'center',
    },
    PWCheckDescIcon: {
        fontSize: '1rem',
        marginRight: `${theme.spacing() / 2}px`,
    },
    PWCheckDescTitle: {
        fontSize: '0.9rem',
    },
    PWCheckDescContent: {
        marginLeft: '1rem',
        paddingLeft: `${theme.spacing() / 2}px`,
    },
})

export default styles
